<template>
	<div>
		<div class="cont">
			<Breadcrumb :pathList="pathList"></Breadcrumb>
			<div class="flex flex-b" style="margin-top: 30px;">
				<div class="title">核心技术</div>
				<div class="search flex">
					<img src="../../assets/icon/search.png" style="width: 16px;height: 16px;" alt="" />
					<input type="text" placeholder="搜索技术" v-model="keyword" @keyup.enter="getArt">
				</div>
			</div>
			<div class="result">共找到 <span>{{total}}</span> 个核心技术</div>

			<div class="flex flex-wrap">
				<div class="itembg1 pointer" v-for="item in list" @click="goDetail(item)">
					<img :src="item.img"
						style="width: 100%;height: 228px;border-radius: 13px;" />
					<div class="det">
						<div class="ititle">{{item.title}}</div>
						<div class="flag">{{item.detail}}</div>
					</div>
				</div>
			</div>
			<Pagination @currentChange='currentChange' :total='total' :page_size='page_size'></Pagination>
		</div>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getArt
	} from "@/api/common";
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import Footer from '../../components/Footer.vue'
	import toTop from '../../components/toTop.vue'
	import Pagination from '../../components/Pagination.vue'
	export default {
		data() {
			return {
				pathList: [{
					title: '首页',
					path: '/index'
				}, {
					title: '核心技术',
					path: ''
				}],
				list: [],
				total: 0,
				page_index: 1,
				page_size: 10,
				keyword: ''
			}
		},
		components: {
			Breadcrumb,
			Footer,
			toTop,
			Pagination
		},
		mounted() {
			this.getArt()
		},
		methods: {
			goDetail(item) {
				this.$router.push({
					path: '/telenologyDetail',
					query: {
						id: item.uuid,
					}
				})
			},
			async getArt() {
				const {
					data,
					status
				} = await getArt({
					page_index: this.page_index,
					page_size: this.page_size,
					title: this.keyword
				})
				this.list = data.result.data
				this.total = data.result.total
			},
			currentChange(e) {
				this.page_index = e
				this.getArt()
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.cont {
		padding: 30px 133px 0;

		.title {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 27px;
			color: #000000;
		}

		.search {
			height: 40px;
			background: #F7F8F9;
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;

			input {
				margin-left: 10px;
				border: none;
				background-color: transparent;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333;

				&:focus {
					outline: none;
				}
			}
		}

		.result {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			color: #000000;
			line-height: 60px;

			span {
				color: #00A73C;
			}
		}

		.itembg1 {
			width: calc(25% - 27px);
			margin-right: 27px;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			background: #FFFFFF;
			border-radius: 13px 13px 13px 13px;
			position: relative;
			margin-bottom: 20px;

			&:nth-child(4n) {
				margin-right: 0;
			}

			.det {
				padding: 14px;
			}

			.ititle {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #000000;
			}

			.flag {
				margin-top: 10px;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				/* 限制文本为2行 */
				overflow: hidden;
				text-overflow: ellipsis;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #999999;
			}
		}
	}
</style>